import { render, staticRenderFns } from "./ResLeadCard.vue?vue&type=template&id=aa3b1106&"
import script from "./ResLeadCard.vue?vue&type=script&lang=js&"
export * from "./ResLeadCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports